/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UsersScopeFilter } from './usersScopeFilter';


export interface UsersIncludeFilterItems { 
    relation?: UsersIncludeFilterItems.RelationEnum;
    scope?: UsersScopeFilter;
}
export namespace UsersIncludeFilterItems {
    export type RelationEnum = 'credentials' | 'userTenant' | 'company' | 'jobPosition' | 'department' | 'area' | 'jobCategory' | 'businessUnit' | 'inactiveReason' | 'city' | 'personalRequisition' | 'vacancy';
    export const RelationEnum = {
        Credentials: 'credentials' as RelationEnum,
        UserTenant: 'userTenant' as RelationEnum,
        Company: 'company' as RelationEnum,
        JobPosition: 'jobPosition' as RelationEnum,
        Department: 'department' as RelationEnum,
        Area: 'area' as RelationEnum,
        JobCategory: 'jobCategory' as RelationEnum,
        BusinessUnit: 'businessUnit' as RelationEnum,
        InactiveReason: 'inactiveReason' as RelationEnum,
        City: 'city' as RelationEnum,
        PersonalRequisition: 'personalRequisition' as RelationEnum,
        Vacancy: 'vacancy' as RelationEnum
    };
}


